import { render, staticRenderFns } from "./guardMarcoK.vue?vue&type=template&id=55f583b9&"
import script from "./guardMarcoK.vue?vue&type=script&lang=js&"
export * from "./guardMarcoK.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports